export default function TeamHeader() {
  return (
    <div className="bg-[#0d1f35] text-white py-16 px-8">
      <div className="max-w-4xl mx-auto">
        <p className="text-dorado-uady text-micro font-bold uppercase tracking-widest mb-3">UADY • FACULTAD DE INGENIERÍA</p>
        <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
          Excelencia en Investigación y<br />Desarrollo Tecnológico
        </h1>
        <p className="text-white/60 text-mini max-w-xl">
          Conoce al equipo de mentes brillantes que lidera la innovación en robótica e industria 4.0 desde el sureste de México.
        </p>
      </div>
    </div>
  );
}
